<template>
  <div class="wt-producing-promo" aria-label="Get the Wochit Go app">
    <!-- background bar grows out from the left -->
    <div class="-bg"></div>
    <!-- top accent line races left to right -->
    <div class="-accent"></div>

    <!-- QR chip rolls in from the left -->
    <div class="-qr-roll">
      <div class="-qr-float">
        <div class="-qr-glow"></div>
        <div class="-qr-card">
          <wochit-go-qr class="-qr" />
          <div class="-qr-scan"></div>
        </div>
        <div class="-corner -tl"></div>
        <div class="-corner -br"></div>
      </div>
    </div>

    <!-- text block slides in from the left -->
    <div class="-text">
      <div class="-kicker">
        <span class="-kicker-label">WHILE YOU WAIT</span>
        <span class="-dots">
          <span class="-dot"></span>
          <span class="-dot"></span>
          <span class="-dot"></span>
        </span>
      </div>
      <div class="-headline">Make video on your <span>phone.</span></div>
      <div class="-sub">Scan to get the Wochit Go app</div>
    </div>
  </div>
</template>

<script>
import WochitGoQr from 'components/WochitGoQr.vue';

export default {
  name: 'ProducingPromoBanner',

  components: {
    WochitGoQr,
  },
};
</script>

<style lang="scss" scoped>
$accent: #00abdf;

@keyframes wtPromoGrowX {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}
@keyframes wtPromoAccentGrow {
  0% {
    transform: scaleX(0);
  }
  60%,
  100% {
    transform: scaleX(1);
  }
}
@keyframes wtPromoRollIn {
  0% {
    opacity: 0;
    transform: translateX(-260px) rotate(-540deg);
  }
  12% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes wtPromoFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes wtPromoQrGlow {
  0%,
  100% {
    transform: scale(0.92);
    opacity: 0.25;
  }
  50% {
    transform: scale(1.06);
    opacity: 0.5;
  }
}
@keyframes wtPromoQrScan {
  0% {
    top: 8px;
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  88% {
    opacity: 1;
  }
  100% {
    top: calc(100% - 11px);
    opacity: 0;
  }
}
@keyframes wtPromoPulseDot {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes wtPromoSlideLeft {
  0% {
    opacity: 0;
    transform: translateX(-22px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.wt-producing-promo {
  position: absolute;
  right: 36px;
  bottom: 34px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 18px 24px 18px 18px;
  pointer-events: none;

  .-bg {
    position: absolute;
    inset: 0;
    border-radius: 18px;
    background: rgba(16, 17, 38, 0.62);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 20px 46px rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    transform-origin: left center;
    animation: wtPromoGrowX 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.85s both;
  }

  .-accent {
    position: absolute;
    top: 0;
    left: 18px;
    right: 24px;
    height: 3px;
    border-radius: 3px;
    background: linear-gradient(90deg, $accent, #33bde6);
    box-shadow: 0 0 10px rgba(0, 171, 223, 0.7);
    transform-origin: left center;
    animation: wtPromoAccentGrow 0.9s cubic-bezier(0.22, 1, 0.36, 1) 1s both;
  }

  .-qr-roll {
    position: relative;
    flex-shrink: 0;
    animation: wtPromoRollIn 0.95s cubic-bezier(0.16, 0.85, 0.3, 1) both;
  }

  .-qr-float {
    animation: wtPromoFloat 5s ease-in-out 1.1s infinite;
  }

  .-qr-glow {
    position: absolute;
    inset: -12px;
    border-radius: 22px;
    background: radial-gradient(
      circle,
      rgba(0, 171, 223, 0.6),
      rgba(0, 171, 223, 0) 70%
    );
    animation: wtPromoQrGlow 3.2s ease-in-out infinite;
  }

  .-qr-card {
    position: relative;
    background: #fff;
    border-radius: 12px;
    padding: 11px;
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }

  .-qr {
    display: block;
    width: 118px;
    height: 118px;
  }

  .-qr-scan {
    position: absolute;
    left: 8px;
    right: 8px;
    height: 3px;
    border-radius: 3px;
    background: linear-gradient(
      90deg,
      rgba(0, 171, 223, 0),
      $accent,
      rgba(0, 171, 223, 0)
    );
    box-shadow: 0 0 12px 2px rgba(0, 171, 223, 0.7);
    animation: wtPromoQrScan 2.4s ease-in-out 1.5s infinite;
  }

  .-corner {
    position: absolute;
    width: 16px;
    height: 16px;
    animation: wtPromoPulseDot 1.8s ease-in-out infinite;

    &.-tl {
      top: -3px;
      left: -3px;
      border-top: 2px solid $accent;
      border-left: 2px solid $accent;
      border-radius: 4px 0 0 0;
    }

    &.-br {
      bottom: -3px;
      right: -3px;
      border-bottom: 2px solid $accent;
      border-right: 2px solid $accent;
      border-radius: 0 0 4px 0;
      animation-delay: 0.9s;
    }
  }

  .-text {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .-kicker {
    display: flex;
    align-items: center;
    gap: 8px;
    animation: wtPromoSlideLeft 0.45s cubic-bezier(0.22, 1, 0.36, 1) 1.05s both;
  }

  .-kicker-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    color: $accent;
  }

  .-dots {
    display: inline-flex;
    gap: 4px;
  }

  .-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: $accent;
    display: inline-block;
    animation: wtPromoPulseDot 1.4s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.25s;
    }
    &:nth-child(3) {
      animation-delay: 0.5s;
    }
  }

  .-headline {
    font-family: 'Montserrat', sans-serif;
    font-size: 19px;
    font-weight: 800;
    color: #fff;
    line-height: 1.2;
    max-width: 200px;
    animation: wtPromoSlideLeft 0.45s cubic-bezier(0.22, 1, 0.36, 1) 1.18s both;

    span {
      color: $accent;
    }
  }

  .-sub {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    color: #b9bcd0;
    line-height: 1.35;
    animation: wtPromoSlideLeft 0.45s cubic-bezier(0.22, 1, 0.36, 1) 1.3s both;
  }
}
</style>
